const WEBSITE_CODES = {
    W002: 'WEBSITE_ALREADY_EXISTS',
};

export default WEBSITE_CODES;
